import { render, staticRenderFns } from "./CouponStock.vue?vue&type=template&id=6f98102e&"
import script from "./CouponStock.vue?vue&type=script&lang=js&"
export * from "./CouponStock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports